"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
exports.FAQMicrodata = ({ items, }) => {
    const microdataObject = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
            items.map(item => {
                return {
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: item.answer,
                    },
                };
            }),
        ],
    };
    if (items && items.length) {
        return (React.createElement(react_helmet_1.Helmet, null,
            React.createElement("script", { type: "application/ld+json" }, JSON.stringify(microdataObject))));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
